import type { SVGProps } from 'react';

const SvgExpand = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="M16 31.8A15.8 15.8 0 1 0 .2 16 15.82 15.82 0 0 0 16 31.8m0-30.1A14.3 14.3 0 1 1 1.7 16 14.32 14.32 0 0 1 16 1.7" />
      <path d="M15.25 23.64h1.5v-6.89h6.89v-1.5h-6.89V8.36h-1.5v6.89H8.36v1.5h6.89z" />
    </g>
  </svg>
);

export default SvgExpand;
